import React, { useState } from "react";
import LandingSection from "../components/LandingSection";
import Footer from "../components/Footer";
import "../styles/UtahAtAGlance.css";

const researchData = [
  {
    university: "Utah State University (USU)",
    centers: [
      {
        centerName: "Research Centers (College of Science)",
        colleges: [
          {
            name: "American Entomological Institute and Insect Collection",
            researchArea: "Hymenoptera, Insect Taxonomy, Biodiversity",
            website: "http://www.amentinst.org/home.php",
          },
          {
            name: "Center for Atmospheric and Space Sciences (CASS)",
            researchArea: "Space Weather, Ionosphere, Atmospheric Science",
            website: "https://cass.usu.edu/",
          },
          {
            name: "Ecology Center",
            researchArea: "Ecology, Conservation, Environmental Science",
            website: "http://ecology.usu.edu/",
          },
          {
            name: "Intermountain Herbarium",
            researchArea: "Botany, Plant Taxonomy, Herbarium Curation",
            website: "https://www.usu.edu/herbarium/",
          },
          {
            name: "USDA Bee Biology and Systematics Laboratory",
            researchArea: "Pollination, Bee Biology, Agricultural Ecology",
            website: "https://www.usu.edu/uaes/",
          },
        ],
      },
      {
        centerName: "Research Centers (Utah Water Research Laboratory - UWRL)",
        colleges: [
          {
            name: "AggieAir",
            researchArea:
              "UAVs, Remote Sensing, Aerial Imaging, Environmental Monitoring",
            website: "https://uwrl.usu.edu/aggieair/",
          },
          {
            name: "Logan River Observatory (LRO)",
            researchArea: "Climate, Hydrology, Water Quality, River Systems",
            website: "https://uwrl.usu.edu/lro/",
          },
          {
            name: "Utah On-Site Wastewater Treatment Training Center",
            researchArea:
              "Wastewater Treatment, Stormwater Management, Training",
            website: "https://uwrl.usu.edu/research/owt/",
          },
          {
            name: "Institute for Natural Systems Engineering (INSE)",
            researchArea: "Water Systems, River Engineering, Ecohydraulics",
            website: "https://uwrl.usu.edu/research/inse",
          },
          {
            name: "Utah Center for Hydrologic Information and Computing (UCHIC)",
            researchArea:
              "Hydrology, Data Modeling, Water Resources, Geospatial Analysis",
            website: "https://uwrl.usu.edu/research/uchic",
          },
          {
            name: "Utah Center for Water Resources Research (UCWRR)",
            researchArea:
              "Water Policy, Water Quality, Water Quantity, Research Grants",
            website: "https://uwrl.usu.edu/research/ucwrr/",
          },
          {
            name: "Utah Water Research Laboratory (UWRL)",
            researchArea:
              "Hydrology, Water Engineering, Environmental Systems, Irrigation",
            website: "https://uwrl.usu.edu/",
          },
        ],
      },
      {
        centerName:
          "Other Centers (USU Office of Research & DigitalCommons@USU)",
        colleges: [
          {
            name: "Bingham Research Center",
            researchArea: "Mining, Energy, Industrial Research",
            website: "https://www.usu.edu/binghamresearch/",
          },
          {
            name: "Center for Anticipatory Intelligence",
            researchArea: "Threat Detection, Strategic Foresight, Security",
            website: "https://www.usu.edu/cai/",
          },
          {
            name: "Center for Colorado River Studies",
            researchArea: "Water Management, River Ecology, Sustainability",
            website: "https://qcnr.usu.edu/coloradoriver/",
          },
          {
            name: "Center for Integrated Biosystems (CIB)",
            researchArea: "Agricultural Biotechnology, Environmental Genomics",
            website: "https://cib.usu.edu/",
          },
          {
            name: "Center for Intersectional Gender Studies",
            researchArea: "Gender Studies, Social Equity, Intersectionality",
            website: "https://www.usu.edu/intersections/",
          },
          {
            name: "Center for the School of the Future",
            researchArea: "Education Innovation, Learning Systems",
            website: "https://cehs.usu.edu/csf/index.php",
          },
          {
            name: "Institute for Disability Research, Policy, and Practice",
            researchArea:
              "Disability Studies, Rehabilitation, Inclusive Services",
            website: "https://idrpp.usu.edu/",
          },
          {
            name: "Janet Quinney Lawson Institute for Land, Water and Air",
            researchArea:
              "Natural Resources, Environmental Policy, Land and Water Research",
            website: "https://www.usu.edu/ilwa/index.php",
          },
          {
            name: "Mountain West Center",
            researchArea: "Regional Studies, Cultural Research",
            website: "https://www.usu.edu/mountainwest/index.php",
          },
          {
            name: "National Center for Hearing Assessment and Management",
            researchArea:
              "Audiology, Hearing Screening, Early Childhood Health",
            website: "https://www.infanthearing.org/",
          },
          {
            name: "Transforming Communities Institute",
            researchArea:
              "Community Engagement, Social Research, Local Development",
            website:
              "https://chass.usu.edu/social-work/transforming-communities-institute/",
          },
          {
            name: "Western Dairy Center",
            researchArea:
              "Dairy Science, Food Processing, Agricultural Engineering",
            website: "https://westerndairycenter.usu.edu/",
          },
          {
            name: "Space Dynamics Laboratory (SDL)",
            researchArea: "Aerospace, Defense Research, Satellite Technology",
            website: "https://www.sdl.usu.edu/",
          },
          {
            name: "Utah Agricultural Experiment Station",
            researchArea:
              "Agricultural Science, Food Safety, Soil and Water Testing",
            website: "https://caas.usu.edu/uaes/",
          },
          {
            name: "Utah Veterinary Diagnostics Laboratory",
            researchArea: "Veterinary Science, Pathology, Animal Health",
            website: "https://www.usu.edu/uvdl/",
          },
          {
            name: "ASPIRE (Aviation Sustainability, Power, and Integrated Research and Education)",
            researchArea:
              "Sustainable Transportation, Electric Aviation, Engineering",
            website: "https://aspire.usu.edu/",
          },
          {
            name: "USU Analytical Laboratories (USUAL)",
            researchArea:
              "Soil Analysis, Environmental Testing, Agricultural Chemistry",
            website: "https://www.usu.edu/analytical-laboratories/",
          },
          {
            name: "Center for Persons with Disabilities (CPD)",
            researchArea: "Disability Research, Autism, Assistive Technology",
            website: "https://cpd.usu.edu/",
          },
        ],
      },
    ],
  },
  {
    university: "University of Utah (U of U)",
    centers: [
      {
        centerName:
          "Health-Related Research Institutes & Centers (U of U Health)",
        colleges: [
          {
            name: "Huntsman Cancer Institute (HCI)",
            researchArea:
              "Cancer, Precision Oncology, Genetics, Clinical Trials, Prevention",
            website: "https://www.huntsmancancer.org",
          },
          {
            name: "Huntsman Mental Health Institute (HMHI)",
            researchArea:
              "Mental Health, Brain Imaging, Addiction, Suicide Prevention, Depression",
            website: "https://healthcare.utah.edu/hmhi",
          },
          {
            name: "Clinical & Translational Science Institute (CTSI)",
            researchArea: "Translational Medicine, Genomics, Bioinformatics",
            website: "https://ctsi.utah.edu",
          },
          {
            name: "Nora Eccles Harrison Cardiovascular Research & Training Institute (CVRTI)",
            researchArea:
              "Cardiovascular Research, Electrophysiology, Metabolism",
            website: "https://cvrti.utah.edu",
          },
          {
            name: "Utah Center for Advanced Imaging Research (UCAIR)",
            researchArea: "Medical Imaging, Radiology, Image Analysis",
            website: "https://medicine.utah.edu/radiology/research/ucair",
          },
          {
            name: "NIH Center for Integrative Biomedical Computing (CIBC)",
            researchArea: "Biomedical Modeling, Simulation, Visualization",
            website: "https://www.sci.utah.edu/cibc/",
          },
          {
            name: "Center for Controlled Chemical Delivery (CCCD)",
            researchArea:
              "Drug Delivery, Macromolecular Therapeutics, Pharmaceutics",
            website:
              "https://pharmacy.utah.edu/center-controlled-chemical-delivery",
          },
          {
            name: "Keck Center for Tissue Engineering (KCTE)",
            researchArea: "Bioengineering, Biomaterials, Nanotechnology",
            website: "https://my.bme.utah.edu/~pat/KCTE/Research/research.html",
          },
          {
            name: "Center for Neural Interfaces",
            researchArea: "Neurotechnology, Neural Engineering",
            website: "https://cni.bme.utah.edu",
          },
          {
            name: "Utah State Center of Excellence for Biomedical Microfluidics",
            researchArea: "Microfluidics, MEMS, Medical Devices",
            website: "https://mems.utah.edu",
          },
          {
            name: "Center for Aging",
            researchArea: "Geriatrics, Cognitive Aging, Memory Disorders",
            website: "https://aging.utah.edu/",
          },
          {
            name: "Center for Human Toxicology",
            researchArea: "Toxicology, Pharmacology, Forensics",
            website: "https://pharmacy.utah.edu/pharmtox/research/cht",
          },
          {
            name: "Center for Medical Innovation",
            researchArea: "MedTech Innovation, Commercialization, Invention",
            website:
              "https://uofuhealth.utah.edu/center-for-medical-innovation",
          },
          {
            name: "Center for Patient Simulation",
            researchArea: "Simulation Training, Medical Education",
            website:
              "https://medicine.utah.edu/anesthesiology/center-for-patient-simulation/",
          },
          {
            name: "Emma Eccles Jones Nursing Research Center",
            researchArea: "Nursing Science, Nursing Education",
            website:
              "https://nursing.utah.edu/research/emma-eccles-jones-research",
          },
          {
            name: "Genetic Science Learning Center",
            researchArea: "Genetics Education, Public Engagement",
            website: "https://learn.genetics.utah.edu/",
          },
          {
            name: "Hartford Center of Geriatric Nursing Excellence",
            researchArea: "Geriatric Nursing, Aging, Gerontology",
            website: "https://nursing.utah.edu/hartford",
          },
          {
            name: "Intermountain Cystic Fibrosis Center",
            researchArea: "Pulmonology, Cystic Fibrosis, Lung Health",
            website:
              "https://healthcare.utah.edu/pulmonaryservices/services/cysticfibrosis/",
          },
          {
            name: "Matheson Center for Health Care Studies",
            researchArea: "Health Policy, Health Services Research",
            website: "https://www.matheson.utah.edu/",
          },
          {
            name: "John A. Moran Eye Center",
            researchArea: "Ophthalmology, Retinal Disorders, Vision Science",
            website: "https://healthcare.utah.edu/moran/",
          },
          {
            name: "Pain Research Center",
            researchArea: "Chronic Pain, Fibromyalgia, Pain Mechanisms",
            website: "https://uofuhealth.utah.edu/pain-research-center",
          },
          {
            name: "Pharmacotherapy Outcomes Research Center",
            researchArea: "Outcomes Research, Pharmacoeconomics",
            website: "https://pharmacy.utah.edu/pharmacotherapy/centers/porc",
          },
          {
            name: "Rocky Mountain Center for Occupational and Environmental Health",
            researchArea: "Occupational Health, Ergonomics, Safety",
            website: "https://medicine.utah.edu/rmcoeh/",
          },
          {
            name: "Utah Addiction Center",
            researchArea: "Addiction Medicine, Substance Abuse",
            website:
              "https://healthcare.utah.edu/hmhi/treatments/addiction-recovery/",
          },
          {
            name: "Utah Center for Promotion of Work Equity Research (U-POWER)",
            researchArea: "Worker Health, Equity, Occupational Research",
            website: "https://medicine.utah.edu/dfpm/research/twh",
          },
          {
            name: "Utah Center for Reproductive Medicine",
            researchArea: "Fertility, IVF, Reproductive Health",
            website: "https://healthcare.utah.edu/fertility/",
          },
          {
            name: "Utah Data Coordinating Center",
            researchArea: "Clinical Trials, Data Management, Biostatistics",
            website: "https://www.uofuhealth.org/utahdcc",
          },
          {
            name: "Utah Center for Advanced Imaging Research",
            researchArea: "MRI, Imaging Science, Imaging Technology",
            website:
              "https://medicine.utah.edu/radiology/radiology-research/ucair/",
          },
          {
            name: "Intermountain Healthcare Simulation Learning Center",
            researchArea: "Simulation, Clinical Training",
            website: "https://nursing.utah.edu/simulation-learning-center",
          },
          {
            name: "University Health Services AIDS Center",
            researchArea: "HIV, AIDS, Infectious Disease",
            website:
              "https://medicine.utah.edu/internal-medicine/infectious-diseases/uaetc",
          },
        ],
      },
      {
        centerName: "University-Other Research Centers and Institutes",
        colleges: [
          {
            name: "Scientific Computing and Imaging Institute (SCI)",
            researchArea:
              "Scientific Visualization, High-Performance Computing, Biomedical Imaging",
            website: "https://www.sci.utah.edu",
          },
          {
            name: "The Nanoinstitute of Utah",
            researchArea: "Nanotechnology, Nanomedicine, Drug Delivery",
            website: "https://nanoinstitute.utah.edu",
          },
          {
            name: "Energy & Geoscience Institute (EGI)",
            researchArea: "Geoscience, Energy Research, Sustainable Resources",
            website: "https://egi.utah.edu",
          },
          {
            name: "Kem C. Gardner Policy Institute",
            researchArea:
              "Public Policy, Economic Development, Demographic Analysis",
            website: "https://gardner.utah.edu",
          },
          {
            name: "Hinckley Institute of Politics",
            researchArea:
              "Political Engagement, Civic Education, Student Leadership",
            website: "https://www.hinckley.utah.edu",
          },
          {
            name: "Tanner Humanities Center",
            researchArea:
              "Humanities Scholarship, Cultural Studies, Interdisciplinary Inquiry",
            website: "https://tanner.utah.edu",
          },
          {
            name: "Wallace Stegner Center for Land, Resources & the Environment",
            researchArea:
              "Environmental Law, Natural Resources Policy, Land-Use Regulation",
            website: "https://www.law.utah.edu/stegner-center/",
          },
          {
            name: "Center for Engineering Innovation (CEI)",
            researchArea:
              "Prototyping, Engineering Design, Technical Education",
            website: "https://www.price.utah.edu/research-centers",
          },
          {
            name: "Energy and Geoscience Institute",
            researchArea:
              "Geoscience, Energy Technology, Sustainable Infrastructure",
            website: "https://www.price.utah.edu/research-centers",
          },
          {
            name: "Utah State University Research Centers",
            researchArea:
              "Water and River Studies, Integrated Biosystems, Ecology, Disability Research",
            website: "https://research.usu.edu/centers-and-facilities",
          },
          {
            name: "Utah Robotics Center",
            researchArea:
              "Robotics, Artificial Intelligence, Machine Perception, Mechanical Engineering",
            website:
              "https://www.bme.utah.edu/research/research-institutes-and-centers/",
          },
          {
            name: "Utah Nuclear Engineering Program (UNEP)",
            researchArea:
              "Nuclear Engineering, Reactor Modeling, Radiation Shielding",
            website: "http://price.utah.edu/research-centers",
          },
        ],
      },
    ],
  },
  {
    university: "Utah Tech University",
    colleges: [
      {
        name: "Climate, Resilience, and Sustainability Center",
        researchArea:
          "Climate Change, Sustainability, Environmental Resilience",
        website: "https://academics.utahtech.edu/climate/",
      },
      {
        name: "Precision Medicine & Functional Genomics Center",
        researchArea:
          "Genomics, Precision Medicine, Protein Evolution, Genetic Disease",
        website: "https://utahtech.edu/genomics/",
      },
      {
        name: "Endurance and Extreme Human Performance Center",
        researchArea:
          "Human Performance, Exercise Science, Nutrition, Physiology",
        website: "https://health.utahtech.edu/health-human-performance/ceehp/",
      },
      {
        name: "Southwest Geosciences Center",
        researchArea:
          "Geosciences, Earth Sciences, Southwest U.S., Education Outreach",
        website: "https://geoscience.utahtech.edu",
      },
      {
        name: "Atwood Innovation Plaza",
        researchArea: "Innovation, Entrepreneurship, Business Incubation",
        website: "https://innovation.utahtech.edu",
      },
      {
        name: "Analytics and Modeling Center",
        researchArea:
          "Data Analytics, Statistical Modeling, Information Systems",
        website: "https://isa.utahtech.edu/inquiry-form/",
      },
    ],
  },
  {
    university: "Other Research-Oriented Entities",
    colleges: [
      {
        name: "Space Dynamics Laboratory (SDL)",
        researchArea: "Aerospace, Satellites, Sensors, Defense",
        website: "https://www.sdl.usu.edu",
      },
      {
        name: "Utah Research Institute (URI)",
        researchArea: "Research Platform, Innovation, Incubation",
        website: "https://www.utahresearchinstitute.org/",
      },
      {
        name: "Advanced Research Institute",
        researchArea: "Clinical Trials, Healthcare, Multispecialty Research",
        website: "https://www.advresearch.org/",
      },
      {
        name: "Alliance for Multispecialty Research – Utah (AMR Utah)",
        researchArea:
          "Clinical Research, Medical Trials, Multispecialty Research",
        website: "https://amrutah.com/",
      },
      {
        name: "West Mountain Observatory (WMO)",
        researchArea: "Astronomy, Astrophysics, Stellar Observation",
        website: "http://wmo.byu.edu/",
      },
    ],
  },
];

const ResearchCenters = () => {
  const [searchQuery, setSearchQuery] = useState("");

  // Function to highlight matching text
  const highlightText = (text, query) => {
    if (!query) return text;
    const regex = new RegExp(`(${query})`, "gi");
    return text.split(regex).map((part, i) =>
      regex.test(part) ? (
        <mark key={i} className="bg-yellow-300 text-black rounded px-1">
          {part}
        </mark>
      ) : (
        part
      )
    );
  };

  // Check if an item matches search query
  const matchesSearch = (college) => {
    const q = searchQuery.toLowerCase();
    return (
      college.name.toLowerCase().includes(q) ||
      college.researchArea.toLowerCase().includes(q)
    );
  };

  const universityCount = researchData.length;
  const totalCollegesCount = researchData.reduce((total, uni) => {
    if (uni.centers) {
      return (
        total +
        uni.centers.reduce((sum, center) => sum + center.colleges.length, 0)
      );
    }
    return total + (uni.colleges ? uni.colleges.length : 0);
  }, 0);

  return (
    <div className="min-h-screen flex flex-col bg-gradient-to-b from-sky-50 to-white">
      <LandingSection
        data={{
          imageName: "research.webp",
          title: `Research Centers and Institutes`,
          visible: true,
        }}
      />

      <div className="utah-at-a-glance-section">
        <div className="utah-at-a-glance-intro">
          <div className="utah-at-a-glance-intro-sec1">
            <h2>
              Research Centers and Institutes: Advancing Innovation Across Utah
            </h2>
          </div>
          <div className="utah-at-a-glance-intro-sec2">
            <p>
              Dive into Utah’s thriving landscape of research and discovery.
              From top-tier universities to specialized research institutes,
              explore how these academic powerhouses drive progress in science,
              technology, engineering, and more.
            </p>
          </div>
        </div>
      </div>

      {/* Search Box */}
      <div className="flex justify-center my-6">
        <input
          type="text"
          placeholder="Search by name or research area..."
          value={searchQuery}
          onChange={(e) => setSearchQuery(e.target.value)}
          className="w-3/4 md:w-1/2 px-4 py-2 border rounded-lg shadow focus:outline-none focus:ring-2 focus:ring-sky-400"
        />
      </div>

      {/* Summary Count */}
      <div className="mt-2 text-2xl font-medium text-[#001f54] text-center">
        Total Universities: <span className="font-bold">{universityCount}</span>{" "}
        | Total Institutes:{" "}
        <span className="font-bold">{totalCollegesCount}</span>
      </div>

      {/* Card Section */}
      <section className="px-4 sm:px-8 lg:px-20 py-12 space-y-16">
        {researchData.map((uni, index) => {
          const centerCount = uni.centers?.length || 0;
          const collegeCount = uni.centers
            ? uni.centers.reduce((acc, c) => acc + c.colleges.length, 0)
            : uni.colleges.length;

          return (
            <div
              key={index}
              className="bg-white rounded-2xl shadow-[0_4px_12px_0_rgba(1,76,178,0.3)] overflow-hidden"
            >
              {/* University Header */}
              <div className="bg-gradient-to-r from-sky-600 to-blue-800 p-6">
                <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold text-black flex items-center justify-center space-x-1">
                  <span>🎓</span>
                  <span>{uni.university}</span>
                  <span className="text-sm bg-[#001f54] text-white px-2 py-0.5 rounded-full">
                    {uni.centers
                      ? `${centerCount} Centers`
                      : `${collegeCount} Institutes`}
                  </span>
                </h2>
              </div>

              <div className="p-6 space-y-10">
                {uni.centers ? (
                  uni.centers.map((center, cIdx) => (
                    <div key={cIdx} className="border-l-4 border-sky-500 pl-4">
                      <div className="mb-4">
                        <h3 className="text-xl md:text-2xl font-semibold text-gray-800 flex items-center space-x-1">
                          <span>🏢</span>
                          <span>{center.centerName}</span>
                          <span className="text-sm bg-sky-100 text-sky-700 px-2 py-0.5 rounded-full">
                            {center.colleges.length} Institutes
                          </span>
                        </h3>
                        <div className="h-1 w-20 bg-sky-400 rounded-full"></div>
                      </div>

                      <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                        {center.colleges
                          .filter((college) => matchesSearch(college))
                          .map((college, idx) => (
                            <div
                              key={idx}
                              className="bg-gray-50 shadow rounded-xl p-6 hover:shadow-lg transition duration-300 hover:scale-105 transform group"
                            >
                              <h4 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-sky-700 transition">
                                {highlightText(college.name, searchQuery)}
                              </h4>
                              <div className="mb-4">
                                <span className="text-sm font-semibold text-gray-700 tracking-wide mb-2">
                                  Research Areas
                                </span>
                                <div className="flex flex-wrap gap-2 mt-2">
                                  {college.researchArea
                                    .split(",")
                                    .map((area, i) => {
                                      const trimmed = area.trim();
                                      const colors = [
                                        "bg-orange-100 text-orange-800",
                                        "bg-emerald-100 text-emerald-800",
                                        "bg-indigo-100 text-indigo-800",
                                        "bg-pink-100 text-pink-800",
                                        "bg-yellow-100 text-yellow-800",
                                        "bg-purple-100 text-purple-800",
                                        "bg-red-100 text-red-800",
                                      ];
                                      const color = colors[i % colors.length];
                                      return (
                                        <span
                                          key={i}
                                          className={`text-xs font-medium px-3 py-1 rounded-full ${color}`}
                                        >
                                          {highlightText(trimmed, searchQuery)}
                                        </span>
                                      );
                                    })}
                                </div>
                              </div>
                              <a
                                href={college.website}
                                target="_blank"
                                rel="noopener noreferrer"
                                className="inline-flex items-center text-sm text-sky-600 hover:text-sky-800 font-medium transition"
                              >
                                Visit Website →
                              </a>
                            </div>
                          ))}
                      </div>
                    </div>
                  ))
                ) : (
                  <div className="border-l-4 border-sky-500 pl-4">
                    <div className="grid gap-6 md:grid-cols-2 lg:grid-cols-3">
                      {uni.colleges
                        .filter((college) => matchesSearch(college))
                        .map((college, idx) => (
                          <div
                            key={idx}
                            className="bg-gray-50 shadow rounded-xl p-6 hover:shadow-lg transition duration-300 hover:scale-105 transform group"
                          >
                            <h4 className="text-lg font-semibold text-gray-800 mb-2 group-hover:text-sky-700 transition">
                              {highlightText(college.name, searchQuery)}
                            </h4>
                            <div className="mb-4">
                              <span className="text-sm font-semibold text-gray-700 tracking-wide mb-2">
                                Research Areas
                              </span>
                              <div className="flex flex-wrap gap-2 mt-2">
                                {college.researchArea
                                  .split(",")
                                  .map((area, i) => (
                                    <span
                                      key={i}
                                      className="text-xs font-medium px-3 py-1 rounded-full bg-sky-100 text-sky-700"
                                    >
                                      {highlightText(area.trim(), searchQuery)}
                                    </span>
                                  ))}
                              </div>
                            </div>
                            <a
                              href={college.website}
                              target="_blank"
                              rel="noopener noreferrer"
                              className="inline-flex items-center text-sm text-sky-600 hover:text-sky-800 font-medium transition"
                            >
                              Visit Website →
                            </a>
                          </div>
                        ))}
                    </div>
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </section>

      <Footer />
    </div>
  );
};

export default ResearchCenters;
